export const userQueryKeys = {
  users: (name) => ['users', name],
};

export const projectQueryKeys = {
  projectById: (id) => ['projectById', id],
  projectsByName: (name) => ['projectByName', name],
};

export const applicationQueryKeys = {
  applicationsByEmployeeId: (employeeId, startDate, endDate) => [
    'applicationsByEmployeeId',
    employeeId,
    startDate,
    endDate,
  ],
};

export const moodleQueryKeys = {
  getMoodleConfigs: (page, size) => ['get-moodle-configs', page, size],
  getMoodleCourses: () => ['get-moodle-courses'],
  getConfiguredCourses: (page, size) => {
    if (page === undefined && size === undefined)
      return ['get-configured-courses'];
    return ['get-configured-courses', page, size];
  },
  courseCompletionReports: (
    year,
    courseConfigId,
    state,
    employeeId,
    page,
    size,
  ) => [
    'get-completion-reports',
    year,
    courseConfigId,
    state,
    employeeId,
    page,
    size,
  ],
  getComplianceStatus: () => ['get-compliance-status'],
  getMyBlockingDecision: () => ['get-my-blocking-decision'],
  courseExclusions: (courseConfigId) => [
    'get-course-exclusions',
    courseConfigId,
  ],
  getTeamComplianceStatus: (page, size, state, employeeName) => [
    'get-team-compliance-status',
    page,
    size,
    state,
    employeeName,
  ],
};

export const reportQueryKeys = {
  projectReport: (filters, page, size, sortBy, sortDirection) => [
    'project-report',
    filters,
    page,
    size,
    sortBy,
    sortDirection,
  ],
};

export const masterdataQueryKeys = {
  officeLocations: () => ['get-office-locations'],
};
